import { z } from "zod";
import { channelSchema } from "./channels.js";
import { sessionSummarySchema } from "./sessions.js";
export const workspaceNavigationResourceTypeSchema = z.enum(["session", "channel"]);
export const workspaceNavigationPinParamsSchema = z.object({
    resourceType: workspaceNavigationResourceTypeSchema,
    resourceId: z.string().trim().min(1).max(200),
});
const workspaceNavigationPinBaseSchema = z.object({
    resourceId: z.string().trim().min(1),
    pinnedAt: z.number().int().nonnegative(),
});
export const workspaceSessionNavigationPinSchema = workspaceNavigationPinBaseSchema.extend({
    resourceType: z.literal("session"),
    resource: sessionSummarySchema,
});
export const workspaceChannelNavigationPinSchema = workspaceNavigationPinBaseSchema.extend({
    resourceType: z.literal("channel"),
    resource: channelSchema,
});
export const workspaceNavigationPinSchema = z.discriminatedUnion("resourceType", [
    workspaceSessionNavigationPinSchema,
    workspaceChannelNavigationPinSchema,
]);
export const listWorkspaceNavigationPinsResponseSchema = z.object({
    pins: z.array(workspaceNavigationPinSchema),
});
export const workspaceNavigationPinResponseSchema = z.object({
    pin: workspaceNavigationPinSchema,
});
export const deleteWorkspaceNavigationPinResponseSchema = z.object({ ok: z.literal(true) });
